// Shared by the contact form and its API, so nothing here may touch the filesystem or process.env: this module
// ships in the browser bundle.

export const CONTACT_LIMITS = { name: 80, email: 254, message: 4000, minMessage: 10 };

export type ContactMessage = { name: string; email: string; message: string };

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** What is wrong with a message, by field, so the form and the API say the same thing. Empty when it is fine. */
export function contactErrors({ name, email, message }: ContactMessage) {
  const errors: Partial<Record<keyof ContactMessage, string>> = {};
  if (!name.trim() || name.length > CONTACT_LIMITS.name) {
    errors.name = `Tell me your name, up to ${CONTACT_LIMITS.name} characters.`;
  }
  if (!EMAIL.test(email.trim()) || email.length > CONTACT_LIMITS.email) {
    errors.email = "That email address doesn't look right.";
  }
  if (message.trim().length < CONTACT_LIMITS.minMessage || message.length > CONTACT_LIMITS.message) {
    errors.message = `Write between ${CONTACT_LIMITS.minMessage} and ${CONTACT_LIMITS.message} characters.`;
  }
  return errors;
}
